<template>
  <transition name="PaB-loader">
    <div class="PaB-loading-spinner" v-if="loading">
      <div class="PaB-spinner"></div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.PaB-loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100px;
  min-width: 100px;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;

  .PaB-spinner {
    position: relative;
    width: 100px;
    height: 100px;
    border-width: 10px;
    border-style: solid;
    border-right-color: transparent !important;
    border-radius: 100%;
    animation: spinner 0.7s linear infinite;
  }
}
.PaB-loader-enter-active,
.PaB-loader-leave-active {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}
.PaB-loader-enter,
.PaB-loader-leave-to {
  opacity: 0;
}
@keyframes spinner {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
